
import { defineComponent } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { formatTime, newDate } from '@toy/utils';
import { jumpDays } from '@/core/utils/index';
import { useList } from '@/hooks/use-list';
import {
  getLogList,
} from '@/api/message-center';
import type { ILogPageReq, ILogPageListItem } from '@/api/message-center/type.d';
import { useCalendarRange } from '@/views/message-center/message-manage/composables/useCalendarRange';
import usePermissionConfig from './use-permission-config';

export default defineComponent({
  components: {

  },
  setup() {
    const $route = useRoute();
    const $router = useRouter();
    let messageId = $route.query.messageId as string;

    // 初始化的发送时间:[发送起点时间,发送终止时间]
    const endCreatedTime = `${formatTime(newDate())}`;
    const startCreatedTime = `${jumpDays(endCreatedTime, -7)}`;
    const {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
    } = useList<ILogPageListItem, ILogPageReq>({
      request: {
        api: getLogList,
        params: {
          messageId: '',
          executeService: '',
          logType: '',
          createdTime: [startCreatedTime, endCreatedTime],
          pageNum: 1,
          pageSize: 10,
        },
        handleParams(paramsObj) {
          if (messageId) {
            params.value.messageId = messageId;
            paramsObj.messageId = messageId;
            $router.replace({
              name: 'MessageCenterLogManageList',
            });
            messageId = '';
          }

          [
            paramsObj.startCreatedTime = startCreatedTime,
            paramsObj.endCreatedTime = endCreatedTime,
          ] = paramsObj.createdTime || [];
          paramsObj.startCreatedTime = `${
            formatTime(paramsObj.startCreatedTime, 'YYYY-MM-DD')
          } 00:00:00`;
          paramsObj.endCreatedTime = `${
            formatTime(paramsObj.endCreatedTime, 'YYYY-MM-DD')
          } 23:59:59`;
          delete paramsObj.createdTime;
          return paramsObj;
        },
      },
    });

    const {
      calendarChange,
      disabledDate,
      createdTimeChange,
    } = useCalendarRange(params);

    const init = () => {
      handleSearch();
    };

    init();

    const permissionConfig = usePermissionConfig();

    return {
      params,
      tableTotal,
      tableData,
      tableLoading,
      handleSearch,
      handleReset,
      handleSizeChange,
      handleCurrentChange,
      calendarChange,
      disabledDate,
      createdTimeChange,
      permissionConfig,
    };
  },
});
